import React from 'react';
import { AppBar, Toolbar, IconButton, Badge, MenuItem, Menu, Typography } from '@material-ui/core';
import { ShoppingCart } from '@material-ui/icons'; 
import { Link, useLocation } from 'react-router-dom'

import useStyles from './styles';
import { FaBars } from 'react-icons/fa';

const Navbar = ({ totalItems, handleToggleSidebar }) => {
    const classes = useStyles();
    const location = useLocation();

    return (
        <>

           <AppBar position='fixed' className={classes.appBar} color="inherit">

                <Toolbar>
                    <div className="btn-toggle" onClick={() => handleToggleSidebar()}>
                        <FaBars/>
                    </div>
                    <Typography component={Link} to="/" variant='h6' className={classes.title} color="inherit">
                        <img src="" alt="" height='25px' className={classes.image} />
                        Silviu Preda | SHOP
                    </Typography>
                    <div className={classes.grow}/>
                    { location.pathname == '/' && (
                        <div className={classes.button}>
                            <IconButton component={Link} to="/cart" aria-label="Show cart items" color="inherit">
                                <Badge badgeContent={totalItems} color="secondary">
                                    <ShoppingCart/>
                                </Badge>
                            </IconButton>
                        </div>
                    )}
                </Toolbar>
           </AppBar>
        </>
    )
}

export default Navbar
